module.exports = __webpack_public_path__ + "media/eat6.9bb2e431.mp4";